import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Zap } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/hooks/useAuth';
import { analytics } from '@/utils/analytics';
import { metaPixel } from '@/utils/meta-pixel';

export const Hero: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleCTAClick = (ctaType: string) => {
    analytics.trackEvent({
      action: 'click',
      category: 'engagement',
      label: 'hero_cta',
      custom_parameters: {
        cta_type: ctaType,
        user_authenticated: isAuthenticated
      }
    });

    // Track with Meta Pixel
    if (!isAuthenticated) {
      metaPixel.trackPricingCTA();
    }

    navigate(isAuthenticated ? '/dashboard' : '/pricing');
  };

  return (
    <section className="bg-gradient-to-br from-blue-600 to-green-600 text-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div>
              <h1 className="text-3xl md:text-4xl font-bold leading-tight mb-4">
                Passez votre DPE de E/F/G → C/D
              </h1>
              <p className="text-lg md:text-xl text-white/90 leading-relaxed">
                Notre IA analyse votre DPE officiel et vous montre exactement quels travaux faire pour gagner des lettres - en dépensant le minimum
              </p>
            </div>

            <div className="flex flex-wrap gap-4">
              <Button
                size="lg"
                variant="outline"
                className="bg-white text-blue-600 border-white hover:bg-blue-50"
                onClick={() => {
                  handleCTAClick('primary');
                  if (isAuthenticated) {
                    navigate('/pricing');
                  } else {
                    navigate('/auth?mode=signup&redirect=/pricing');
                  }
                }}
              >
                Analyser Mon DPE Maintenant (2021 et ultérieur)
              </Button>
            </div>

            <div className="flex items-center space-x-6 text-sm">
              <div className="flex items-center">
                <Shield className="w-5 h-5 mr-2" />
                <span>Données ADEME officielles</span>
              </div>
              <div className="flex items-center">
                <Zap className="w-5 h-5 mr-2" />
                <span>Analyse en 30 secondes</span>
              </div>
            </div>
          </div>

          <div className="hidden md:block">
            <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl shadow-2xl">
              <img
                src="/assets/Dpewizard_Hero.jpg"
                alt="DPEWizard - Analyse de DPE"
                className="w-full h-auto rounded-lg"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;